import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';
import { BehaviorSubject, Observable } from 'rxjs';
import { ArFeatureBaseModel } from './arFeatureBase.model';
import { ArFeatureBaseOutboundService } from './arFeatureBaseOutbound.service';
import { ArFeatureDataState } from './arFeatureDataState.enum';

export abstract class ArFeatureBaseStateServiceAdapter<Model extends ArFeatureBaseModel>
    implements ArFeatureBaseOutboundService<Model>
{
    protected domainModel: Model;
    private dataStateSubject = new BehaviorSubject<ArFeatureDataState>(ArFeatureDataState.UNDEFINED);
    dataState$: Observable<ArFeatureDataState> = this.dataStateSubject.asObservable();

    updateState(state: ArFeatureDataState): void {
        this.dataStateSubject.next(state);
    }
    updateDomainModel(domainModel: Model) {
        this.domainModel = domainModel;
    }

    abstract getModifiedData(original: IAnnualReport): IAnnualReport;
}
